module.exports = __webpack_public_path__ + "img/a83774e.jpg";